import React from 'react';
import { Button as MUIButton } from '@mui/material';
import './Theming.css'; // Import your CSS file
import './ButtonStyles.css'; // Import custom button styles

export default function ButtonComponent(props) {
  const { 
    backgroundColor, 
    color, 
    className, 
    children, 
    sx = {}, 
    style = {}, 
    ...otherProps 
  } = props;

  // Determine text color based on background color for contrast
  const getTextColor = () => {
    // Dark backgrounds that need light text
    if (
      backgroundColor === 'var(--primary)' || 
      backgroundColor === 'var(--error)' || 
      backgroundColor === 'var(--dark)' ||
      backgroundColor === 'var(--danger)'
    ) {
      return '#ffffff';
    }
    // Use provided color or default
    return color || (sx?.color || style?.color || 'inherit');
  };

  // Merge all styles with our text color override
  const mergedStyle = {
    backgroundColor: backgroundColor,
    color: getTextColor(),
    fontWeight: 500,
    ...(style || {})
  };

  return (
    <MUIButton
      {...otherProps}
      className={`custom-button ${className || ''}`}
      style={mergedStyle}
      sx={sx}
    >
      {children}
    </MUIButton>
  );
}
